/** Select an element
 * @param {String} selector css-like selection
 * @returns {Node} the node
 */
function select(selector) {
	return document.querySelector(selector);
}

/** Select multiple elements
 * @param {String} selector css-like selection
 * @returns {NodeList} the nodes
 */
function selects(selector) {
	return document.querySelectorAll(selector);
}

import Blazy from "./blazy.min.js";

import SVGInjector from "../../../node_modules/svg-injector";
SVGInjector(selects(".svg-inject"));

import "./fittext";
const textToFit = selects(".fit");

/** On startup run all this
 *	@returns {void} nothing
 */
function init() {
	var bLazy = new Blazy({ selector: ".lazy" });

	let logo = select(".logo");

	// move banner up when scrolling
	window.addEventListener("scroll", () => {
		console.log("scroll");
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		if (scrollTop > 100) {
			if (!logo.classList.contains("collapsed")) {
				logo.classList.add("collapsed");
			}
		} else {
			if (logo.classList.contains("collapsed")) {
				logo.classList.remove("collapsed");
			}
		}
	});

	// make the mobile menu work
	const mobileMenu = select(".mobile-menu");
	const mobileBtn = select(".menu-button");
	mobileBtn.addEventListener("click", () => {
		if (mobileMenu.classList.contains("opened")) {
			mobileMenu.classList.add("closing");
			setTimeout(() => {
				mobileMenu.classList.remove("closing");
				mobileMenu.classList.remove("opened");
				select("body").classList.remove("menu-open");
				headerCalc();
			}, 310);
		} else {
			mobileMenu.classList.add("opened");
			select("body").classList.add("menu-open");
			for (let i = 0; i < textToFit.length; i++) {
				window.fitText(textToFit[i], 1.2, { maxFontSize: "36" });
			}
		}
	});

	// calculate header height
	const header = select("header.navigation");
	let headerCalc = function() {
		setTimeout(() => {
			const headerHeight = header.offsetHeight;
			console.log(headerHeight);
			select("body").style.paddingTop = headerHeight + "px";
		}, 1);
	};
	headerCalc();
	window.addEventListener("resize", headerCalc);

	const langSwitches = selects(".language");
	for (let i = 0; i < langSwitches.length; i++) {
		langSwitches[i].addEventListener("change", function() {
			window.location.href = this.value;
		});
	}
}

// in case the document is already rendered
if (document.readyState !== "loading") {
	init();
} else {
	// modern browsers
	document.addEventListener("DOMContentLoaded", init);
}
